// tinymce

'use strict';

icing.watch('textarea[data-tinymce]', element => {
    const tinymce = window.tinyMCE ?? window.tinymce ?? null;
    if (!tinymce) {
        return;
    }

    if (!element.id) {
        element.setAttribute('id', 'tinymce-' + Math.random().toString(36).substring(2, 11));
    }

    const defaultOptions = {
        license_key: 'gpl',
        promotion: false,
        menubar: 'edit view insert format tools table',
        plugins: 'advlist autolink lists link image charmap preview anchor ' +
            'searchreplace visualblocks code fullscreen insertdatetime media table code help wordcount',
        toolbar: 'undo redo | formatselect | bold italic backcolor | ' +
            'alignleft aligncenter alignright alignjustify | ' +
            'bullist numlist outdent indent | removeformat | link image table | code fullscreen'
    };

    const userOptions = element.dataset.tinymce ? JSON.parse(element.dataset.tinymce) : {};

    const options = {
        ...defaultOptions,
        ...userOptions
    };

    const editor = tinymce.EditorManager.createEditor(element.id, options);
    element.tinymce = editor;

    editor.render();

});

